import  * as InstrumentUptimeConstants from './InstrumentUptimeConstants';
import { produce } from "immer";
const assign = Object.assign || require('object.assign');


// The initial application state
const initialState = {};

// Takes care of changing the application state
export default function InstrumentUptimeReducer(state = initialState, action) {
    switch (action.type) {
        case InstrumentUptimeConstants.INSTRUMENT_UPTIME_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }

            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isUptimedataFetching: false,
                    isUptimedataFetched: false,
                    graphPointFetching: false,
                    graphPointFetched: false,
                    percentage: 0,
                    graphObject: {}
                };
            });
            return assign({}, state, newState);
        }
        case InstrumentUptimeConstants.INSTRUMENT_UPTIME_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case InstrumentUptimeConstants.INSTRUMENT_RUNNING_STATUS_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUptimedataFetching: true,
                    isUptimedataFetched : false,
                };
            });
            return assign({}, state, newState);
        }
        case  InstrumentUptimeConstants.INSTRUMENT_RUNNING_STATUS_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUptimedataFetching: false,
                    isUptimedataFetched : true,
                    percentage: action.payload.newState
                };
            });
            return assign({}, state, newState);
        }
        case InstrumentUptimeConstants.INSTRUMENT_RUNNING_STATUS_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUptimedataFetching: false,
                    isUptimedataFetched : false,
                };
            });
            return assign({}, state, newState);
        }
        case InstrumentUptimeConstants.INSTRUMENT_GRAPH_POINTS_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    graphPointFetching: true,
                    graphPointFetched : false,
                    graphObject:{}
                };
            });
            return assign({}, state, newState);
        }
        case  InstrumentUptimeConstants.INSTRUMENT_GRAPH_POINTS_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    graphPointFetching: false,
                    graphPointFetched : true,
                    graphObject: action.payload.newState
                };
            });
            return assign({}, state, newState);
        }
        case InstrumentUptimeConstants.INSTRUMENT_GRAPH_POINTS_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    graphPointFetching: false,
                    graphPointFetched : false,
                    graphObject:{}
                };
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}